export const EURO_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'EL',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'IS',
  'LI',
  'NO',
  'CH',
  'AL',
  'ME',
  'MK',
  'RS',
  'AD',
  'BA',
  'MD',
  'MC',
  'SM',
  'GB',
  'UK',
  'VA',
];

export const SUBSCRIPTION_PLAN_VARIANTS_USD = {
  default: process.env.NEXT_PUBLIC_PLANS_GROUP_USD as string,
};

export const SUBSCRIPTION_PLAN_VARIANTS_EURO = {
  default: process.env.NEXT_PUBLIC_PLANS_GROUP_EUR as string,
};

export const PAYMENT_MODAL_QUERY_PARAM = 'show_payment';
